export const styleGuide = {
  styleGuide: {
    demoForm: {
      subscriptiontypes: {
        title: 'Subscription Type',
        subscriptiontype_basic: 'Basic',
        subscriptiontype_premium: 'Premium',
        subscriptiontype_vip: 'VIP',
      },
      document: {
        title: 'Document (CPF/CNPJ)',
        placeholder: '...',
      },
      phone: {
        title: 'Phone',
        placeholder: '...',
      },
      comment: {
        title: 'Comment',
        placeholder: 'leave your comment here...',
      },
    },
  },
};
